/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react'

import iconDropDown from "../../assets/images/icondropdown.svg";
import link from "../../assets/images/link.svg";
import more from "../../assets/images/more.svg";
import down from "../../assets/images/down.svg";
import featured from "../../assets/images/featured.svg";

export const RightSidebar = ({
  styles,
  pageData,
  setPageData,
  setIslugChanged,
  changeSlug,
  convertToSlug,
  errorMessage,
  setErrorMessage,
  published,
  draft,
  isPublishedOpen,
  setIsPublishedOpen,
  isDraftOpen,
  setIsDraftOpen,
  isLoading,
  isDraftLoading,
  handlePublish,
  handleDraft,
  handleChangeToDraft,
  handleChangeToPublish,
  handelSingleDelete,
  pageId,
  setIsDraftLoading,
  setIsLoading,
  validateDraftPage,
  bannerList,
  handleBannerSelect,
  bannerDropdownRef,
  openBanner,
  setOpenBanner,
  selectedFeatureImage,
  setSelectedFeatureImage,
  showUploadMediaPopup,
  setShowUploadMediaPopup,
  uploadMediaPopupFor,
  setUploadMediaPopupFor,
  uploadMediaPopupTab,
  setUploadMediaPopupTab,
  isImageDragging,
  setImageDragging,
  handleFeatureImageDrop,
  handleFileDragOver,
  handleFileDragLeave,
  handleMeidaUpload
}) => {

  const [isOpenSlugDropdown, setOpenSlugDropdown] = useState(true);
  const [isOpenExpertDropdown, setOpenExpertDropdown] = useState(true);
  const [isOpenBannerDropdown, setOpenBannerDropdown] = useState(true);
  const [isOpenFeatureImageDropdown, setOpenFeatureImageDropdown] = useState(true);
  const dotsRef = useRef(null);
  const dotsMobileRef = useRef(null);

  const toggleDropdownSlug = () => {
    setOpenSlugDropdown(!isOpenSlugDropdown);
  };
  const toggleDropdownExpertImage = () => {
    setOpenExpertDropdown(!isOpenExpertDropdown);
  };
  const toggleDropdownBannerImage = () => {
    setOpenBannerDropdown(!isOpenBannerDropdown);
  };

  const toggleDropdownFeatureImage = () => {
    setOpenFeatureImageDropdown(!isOpenFeatureImageDropdown);
  };

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (!e.target) return;

      if (isDraftOpen && !e.target.closest(".publishedButtonsList") && !e.target.closest(".actionDots")) {
        setIsDraftOpen(false);
      }
      if (isPublishedOpen && !e.target.closest(".publishedButtonsList") && !e.target.closest(".actionDots")) {
        setIsPublishedOpen(false);
      }
      if (bannerDropdownRef?.current && !e.target.closest(".banner-dropdown-wrapper")) {
        setOpenBanner(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [isDraftOpen, isPublishedOpen]);

  return (
    <div className={`${styles.newpageRight} page-right-sidebar`}>
      <div className={styles.buttonsDesktop}>
        {(published === false && draft === false) ? (
          <div className={styles.newpageRightButtons}>
            <button
              className={`${styles.primaryButton} ${styles.publishButton}`}
              onClick={handlePublish}
            >
              {isLoading ? (
                <div className={`ringLoader loaderContinue`}></div>
              ) : (
                <p>Publish</p>
              )}
            </button>
            <button
              className={`${styles.secondaryButton} ${styles.draftButton} draft`}
              onClick={() => {
                if (!validateDraftPage()) return;
                setIsDraftLoading(true);
                handleDraft();
              }}
            >
              {isDraftLoading ? (
                <div className={`ringLoader loaderContinue`}></div>
              ) : (
                <p>Save as draft</p>
              )}
            </button>
          </div>
        ) : published === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsRef}>
              <button
                className={`${styles.primaryButton} ${styles.updatePagebtn}`}
                onClick={handlePublish}
              >
                {isLoading ? (
                  <div className={`ringLoader loaderContinue`}></div>
                ) : (
                  <p>Update</p>
                )}
              </button>
              {
                (pageData?.slug !== 'home' && pageData?.slug !== 'blogs') &&
                <button
                  className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                  onClick={() => setIsPublishedOpen(!isPublishedOpen)}
                >
                  <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
                </button>
              }
              {isPublishedOpen && pageId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToDraft}
                    >
                      Change to draft
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handelSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span>{pageData?.status?.charAt(0).toUpperCase() + pageData?.status?.slice(1)}</span>
            </p>
          </div>
        ) : draft === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsRef}>
              <button
                className={`${styles.primaryButton} ${styles.updateDraftButton}`}
                onClick={() => { if (!validateDraftPage()) return; setIsLoading(true); handleDraft(); }}
              >
                {isLoading ? (
                  <div className={`ringLoader loaderContinue`}></div>
                ) : (
                  <p>Update Draft</p>
                )}
              </button>
              {
                (pageData?.slug !== 'home' && pageData?.slug !== 'blogs') &&
                <button
                  className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                  onClick={() => setIsDraftOpen(!isDraftOpen)}
                >
                  <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
                </button>
              }
              {isDraftOpen && pageId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToPublish}
                    >
                      Publish
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handelSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span className={styles.draftStatus}>Draft</span>
            </p>
          </div>
        ) : (
          ''
        )}
      </div>
      <div className={`${styles.newPageRightRow} ${styles.newPageRightRowURL}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownSlug}>
          <span>URL address</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenSlugDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
            <img className={styles.adressLink} src={link} alt="Search" />
            <input
              type="text"
              placeholder="URL"
              autoComplete="off"
              disabled={pageData?.slug === 'home' || pageData?.slug === 'blogs'}
              value={pageData?.slug}
              onChange={(e) => {
                setPageData({ ...pageData, slug: e.target.value });
                setIslugChanged(true)
                if (e.target.value === '') {
                  setIslugChanged(false)
                }
                setErrorMessage({ ...errorMessage, slug: '' })
              }}
              onBlur={(e) => {
                let urlValue = convertToSlug(e.target.value);
                setPageData({ ...pageData, slug: urlValue });
                if (e.target.value === '') {
                  changeSlug(pageData?.title);
                }
              }}
            />
          </div>
          {errorMessage?.slug && <p className='error-message'>{errorMessage?.slug}</p>}
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        {/* <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} >
          <span>Show Product</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div> */}
        <div className={`${styles.contentDrop}`}>
          <div className={`${styles.adressInputBlock} ${styles.stockManage}`}>
            <div className={styles.trackStock}>
              <input
                type="checkbox"
                checked={pageData?.titleShowed !== false}
                onChange={(e) => {
                  setPageData({ ...pageData, titleShowed: e.target.checked });
                }}
              />
              <p>Show Title</p>
            </div>
            <div className={styles.trackStock}>
              <input
                type="checkbox"
                checked={pageData?.showHighlight}
                onChange={(e) => {
                  setPageData({ ...pageData, showHighlight: e.target.checked });
                }}
              />
              <p>Show Highlight</p>
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownExpertImage}>
          <span>SEO Data</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>

        <div className={`${styles.contentDrop} ${isOpenExpertDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} `}>
            <input
              type="text"
              placeholder="Enter SEO Title"
              onChange={(e) => { setPageData({ ...pageData, seoTitle: e.target.value }) }}
              value={pageData?.seoTitle}
              style={{ paddingLeft: 12 }}
            />
            <textarea
              autoComplete="off"
              className={styles.textExpert}
              rows={5}
              onChange={(e) => { setPageData({ ...pageData, seoContent: e.target.value }) }}
              value={pageData?.seoContent}
              placeholder="Enter SEO Content"
            />
            <input
              type="text"
              placeholder="Enter Keyword"
              onChange={(e) => { setPageData({ ...pageData, keyword: e.target.value }) }}
              value={pageData?.keyword}
              style={{ paddingLeft: 12 }}
            />
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow} ${styles.bannerDropdownWrapper}`} >
        <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap}`} onClick={toggleDropdownBannerImage}>
          <span>Banner</span>
          <div className={styles.dropdownIcon}>
            <img src={iconDropDown} alt="dropdown" />
          </div>
        </div>
        <div className={`${styles.contentDrop} ${isOpenBannerDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
          <div className={`${styles.adressInputBlock} ${styles.urlInput}`}>
            <div className={`dropdown-wrapper banner-dropdown-wrapper`} ref={bannerDropdownRef}>
              <div className="dropdown-header" onClick={() => setOpenBanner(!openBanner)}>
                <span className="title">
                  {Array.isArray(pageData?.bannerId) && pageData?.bannerId.length > 0 ? `${pageData?.bannerId.length} selected` : "Select banner"}
                </span>
                <span className={`arrow ${openBanner ? "rotate" : ""}`}>
                  <img src={down} alt="down" />
                </span>
              </div>
              {openBanner && (
                <div className="dropdown-list">
                  {bannerList?.map((banner, index) => (
                    <label key={index} className="dropdown-item">
                      <input
                        type="checkbox"
                        checked={pageData?.bannerId?.some((b) => b?.bannerId === banner?.bannerId)}
                        onChange={() => handleBannerSelect(banner)}
                      />
                      <span>{banner?.bannerTitle}</span>
                    </label>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className={`${styles.newPageRightRow} ${styles.desktopFeatures}`}>
        <div className={`${styles.newPageRight}`}>
          <div className={`${styles.newPageRightTitle} ${styles.iconDropWrap} ${styles.imageUpload}`} onClick={toggleDropdownFeatureImage}>
            <span>Featured image</span>
            <div className={`${styles.dropdownIcon}`}>
              <img src={iconDropDown} alt="dropdown" />
            </div>
          </div>

          <div className={`${styles.contentDrop} ${isOpenFeatureImageDropdown ? `${styles.expanded}` : `${styles.collapse}`}`}>
            <div>
              <div className={`${styles.newPageRightRow} ${styles.imageUploadBox} ${isImageDragging ? styles.dragging : ''}`}
                onDragOver={handleFileDragOver}
                onDragLeave={handleFileDragLeave}
                onDrop={handleFeatureImageDrop}
                onClick={(e) => { e.stopPropagation(); setShowUploadMediaPopup(true); setUploadMediaPopupFor('feature-image'); setUploadMediaPopupTab('media'); }}
              >
                {selectedFeatureImage ? (
                  <img src={selectedFeatureImage?.[0]?.url} className={`${styles.featuredImg}`} alt='feature-image' />
                ) : (
                  <>
                    <div id="newpageImageUpload" className={`${styles.newpageImageUpload}`}>
                      <div className={`${styles.featureImgMiddleContent}`}>
                        <img className={`${styles.fileUploadCover_Img}`} src={featured} alt="FeaturedImage" />
                        <p className={`${styles.newPageImageUploadText}`}>
                          <span>Upload</span> or <span>Open Media Library</span>
                          <br />
                          JPG, PNG (max. 128MB)
                        </p>
                      </div>
                    </div>
                    <input type="file" id="feature-img" accept="image/*" hidden />
                  </>
                )}
              </div>
            </div>
            {errorMessage?.featureImage && <p className='error-message'>{errorMessage?.featureImage}</p>}
          </div>

        </div>

      </div>
      <div className={styles.buttonsMobile}>
        {(published === false && draft === false) ? (
          <div className={styles.newpageRightButtons}>
            <button
              className={`${styles.primaryButton} ${styles.publishButton}`}
              onClick={handlePublish}
            >
              {isLoading ? (
                <div className={styles.ringLoader}></div>
              ) : (
                <p>Publish</p>
              )}
            </button>
            <button
              className={`${styles.secondaryButton} ${styles.draftButton}`}
              onClick={() => { if (!validateDraftPage()) return; setIsDraftLoading(true); handleDraft(); }}
            >
              {isDraftLoading ? (
                <div className={styles.ringLoader}></div>
              ) : (
                <p>Save as draft</p>
              )}
            </button>
          </div>
        ) : published === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsMobileRef}>
              <button
                className={`${styles.primaryButton} ${styles.updatePagebtn}`}
                onClick={handlePublish}
              >
                {isLoading ? (
                  <div className={styles.ringLoader}></div>
                ) : (
                  <p>Update</p>
                )}
              </button>
              {
                (pageData?.slug !== 'home' && pageData?.slug !== 'blogs') &&
                <button
                  className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                  onClick={() => setIsPublishedOpen(!isPublishedOpen)}
                >
                  <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
                </button>
              }
              {isPublishedOpen && pageId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToDraft}
                    >
                      Change to draft
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handelSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span>{pageData?.status?.charAt(0).toUpperCase() + pageData?.status?.slice(1)}</span>
            </p>
          </div>
        ) : draft === true ? (
          <div>
            <div className={styles.newpageRightButtons} ref={dotsMobileRef}>
              <button
                className={`${styles.primaryButton} ${styles.updateDraftButton}`}
                onClick={() => {
                  if (!validateDraftPage()) return;
                  setIsLoading(true);
                  handleDraft();
                }}
              >
                {isLoading ? (
                  <div className={styles.ringLoader}></div>
                ) : (
                  <p>Update Draft</p>
                )}
              </button>
              {
                (pageData?.slug !== 'home' && pageData?.slug !== 'blogs') &&
                <button
                  className={`${styles.newpageMoreButtons} ${styles.secondaryButton}`}
                  onClick={() => setIsDraftOpen(!isDraftOpen)}
                >
                  <img src={more} alt="Dots" className={`actionDots ${styles.actionDots}`} />
                </button>
              }
              {isDraftOpen && pageId && (
                <div className={`publishedButtonsList ${styles.publishedButtonsList}`}>
                  <ul>
                    <li
                      className={styles.publishLi}
                      onClick={handleChangeToPublish}
                    >
                      Publish
                    </li>
                    <li
                      className={styles.publishLi}
                      onClick={handelSingleDelete}
                    >
                      Delete
                    </li>
                  </ul>
                </div>
              )}
            </div>
            <p className={styles.publishStatus}>
              Status: <span className={styles.draftStatus}>Draft</span>
            </p>
          </div>
        ) : (
          ''
        )}

      </div>
    </div>
  )
}
